export const GET_INVESTOR_INFO = `v1/investor-info/`;
export const ADD_INVESTOR_INFO = `/v1/investor-info`;
export const ADD_INVESTOR_IMAGE = `/v1/media/investor-info`;
export const GET_INVESTOR_IMAGE = `v1/media/investor-info`;
export const DELETE_INVESTOR_INFO= `/v1/investor-info/`;
export const GET_INVESTOR_INFO_BY_ID = `/v1/investor-info/`
export const UPDATE_INVESTOR_INFO = `v1/investor-info/`;